import OfferContainer from './OfferContainer';

export default OfferContainer;
